<template>
  <Dialog
    width="644px"
    height="unset"
    titleAlign="left"
    :title="$$t('create.add_media_link')"
    :visible="renderData.visible"
    @close="closeDialog"
    mobileRenderType="drawerDialog"
  >
    <div
      class="height-all add-link-inputlink flex-column"
      :class="{ 'add-link-inputlink--mobile': createRenderType == 'mobile' }"
    >
      <div class="add-link-inputlink-edit flex" @click="onInputAreaClick">
        <textarea
          ref="refInput"
          :placeholder="$$t('create.add_media_link_placeholder')"
          class="flex1 width-0"
          :value="renderData.linkurl"
          @input="onInput"
          @change="onChange"
          @compositionstart="handleCompositionStart"
          @compositionend="handleCompositionEnd"
        />

        <div class="add-link-inputlink-edit-count">
          {{ renderData.linkurl?.length ?? 0 }}/ {{ MAX_TITLE_LENGTH }}
        </div>
      </div>

      <div class="add-link-inputlink-done-btn-box">
        <div class="add-link-inputlink-done-btn">
          <Button
            @click="onDoneClick"
            :renderStyle="{
              '--padding': '0',
              '--width': '100%',
              '--height': '48px',
              '--borderRadius': '50px',
              '--fontColor': '#000',
              '--fontSize': '16px',
              '--fontWeight': 'normal',
              '--border': 'none',
              '--background':
                'linear-gradient(120deg, rgb(79, 222, 255, 1) -1%, rgb(230, 117, 255, 1) 100%)', //#94ADFF
              '--backgroundHover':
                'linear-gradient(120deg, rgb(79, 222, 255, 0.75) -1%, rgb(230, 117, 255, 0.75) 100%)',
              '--fontColorHover': '#000',
            }"
          >
            {{ $$t("create.done") }}
          </Button>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue"
import { useRouter, useRoute } from "vue-router"
import message from "@/components/functionCallComponent/message.jsx"
import feedListApi from "@/api/api/feedListApi.js"

import { $$language, $$t } from "@/i18n/i18n.js"
import Dialog from "@/components/basic/dialog/Dialog.vue"
import Button from "@/components/basic/button/Button.vue"

import objectStorage, {
  getObjectStorageFullUrl,
} from "@/lib/objectStorage/objectStorage.js"

import { storeToRefs } from "pinia"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"

const createLayoutStore = useCreateLayoutStore()
const { createRenderType } = storeToRefs(createLayoutStore)

const globalProperties = (
  getCurrentInstance() || window?.$getVueCurrentInstance?.()
).appContext?.config?.globalProperties

const MAX_TITLE_LENGTH = 500

const Router = (getCurrentInstance() || window?.$getVueCurrentInstance?.())
  .appContext?.config?.globalProperties?.$router
const props = defineProps({
  linkurl: {
    type: String,
    default: "",
  },
  visible: {
    type: Boolean,
    default: true,
  },
})
const emits = defineEmits(["update:visible", "done"])

const refInput = ref(null)
const renderData = reactive({
  visible: props.visible,
  linkurl: props.item?.linkurl,
})

const onInputAreaClick = (e) => {
  refInput.value?.focus()
}
const handleCompositionStart = () => {
  renderData.inputing = true
}

const handleCompositionEnd = (e) => {
  renderData.inputing = false
  onInput(e)
}
const onInput = (e) => {
  if (!renderData.inputing) {
    if (e.target.value.length > MAX_TITLE_LENGTH) {
      e.target.value = e.target.value.slice(0, MAX_TITLE_LENGTH)
    }
    renderData.linkurl = e.target.value
    emits("update:linkurl", renderData.linkurl)
  }
}
const onChange = (e) => {
  emits("update:linkurl", renderData.linkurl)
}

const onClose = () => {
  renderData.visible = false
  renderData.linkurl = ""
  emits("update:visible", false)
  emits("cancel")
}

const onDoneClick = async () => {
  emits("done", renderData.linkurl || "")
}

const closeDialog = () => {
  renderData.visible = false
}

watch(
  () => props.visible,
  (val) => {
    renderData.visible = props.visible
    renderData.linkurl = props.linkurl
    if (props.visible) {
      refInput.value?.focus()
    }
  }
)

watch(
  () => renderData.visible,
  (val) => {
    emits("update:visible", val)
  }
)

onMounted(() => {
  refInput.value?.focus()
})
</script>
<style lang="scss">
.add-link-inputlink {
  padding: 13px 40px 32px 40px;

  .add-link-inputlink-edit {
    height: 200px;
    border-radius: 8px;
    padding: 16px 16px 14px 16px;
    background: rgba(255, 255, 255, 0.1);
    align-items: center;
    flex-direction: column;
    textarea {
      height: 100%;
      width: 100%;
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: normal;
      line-height: 20px;
      color: #ffffff;
      border: none;
      outline: none;
      background: transparent;
      color: #ffffff;
      height: 0;
      flex: 1;
      resize: none;
      &::placeholder {
        color: rgba(255, 255, 255, 0.5) !important;
      }
    }
    .add-link-inputlink-edit-count {
      font-size: 12px;
      font-weight: normal;
      line-height: 20px;
      text-align: right;
      color: rgba(255, 255, 255, 0.5);
      margin: 8px 0 0 0 0;
      width: 100%;
    }
  }

  .add-link-inputlink-done-btn-box {
    .add-link-inputlink-done-btn {
      margin: 20px auto 0 auto;
      width: 100%;
    }
  }
  &.add-link-inputlink--mobile {
    padding: 15px 16px 16px 16px;
    .add-link-inputlink-done-btn-box {
      .add-link-inputlink-done-btn {
        margin: 16px auto 16px auto;
      }
    }
  }
}
</style>
